import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

type Props = {
    value: string;
    onChange: (arg1: string) => void;
    onEnter?: () => void;
};

export function Hostname(props: Props) {
    return (
        <FormField
            innerId='hostname'
            label='Hostname'
            errorMessage={null} // TODO
        >
            <TextField
                // @ts-expect-error
                name='hostname'
                placeholder='smtp.google.com'
                title='Hostname'
                type='text'
                autoFocus={true}
                value={props.value}
                onChange={props.onChange}
                onEnter={props.onEnter}
            />
        </FormField>
    );
}
